import React from 'react'

const RewardLogo = ({ fontSize = 45, fontWeight = 400, pointsTop = '5px', pointsRight = '-5px', pointFontSize = 11 }) => {
  return (
    <div style={{ position: 'relative', padding: 0, margin: 0 }}>
      <h1 style={{ margin: 0 }}>
        <span style={{ fontWeight, fontSize }}>REWARD</span>
      </h1>
      <div style={{ fontSize: pointFontSize, transform: 'rotate(-90deg)', position: 'absolute', top: pointsTop, right: pointsRight, transformOrigin: 'right center' }}>points</div>
    </div>
  )
}

export default RewardLogo
